// src/components/PaymentPages.jsx
// Success and Cancel pages that Stripe redirects to

import { useEffect, useState } from 'react';
import { getRunStatus } from '../api';

const GOLD = '#C8A84B';
const DARK = '#0D1B2A';

// ── Payment Success Page ──────────────────────────────────────────────────────
// Stripe redirects here after successful payment
// URL: /payment/success?session_id=xxx&matter_id=xxx&perspective=xxx
// The webhook has already fired and started the run.
// We just need to poll run status and redirect to the matter.

export function PaymentSuccess({ token, onGoToMatter }) {
  const [status, setStatus] = useState('Verifying payment…');

  useEffect(() => {
    const params      = new URLSearchParams(window.location.search);
    const matterId    = params.get('matter_id');

    if (!matterId) {
      setStatus('Payment received. Return to your matters to view the report.');
      return;
    }

    // Redirect to matter after brief delay
    setStatus('Payment confirmed. Starting your analysis…');
    setTimeout(() => {
      onGoToMatter(matterId);
    }, 2500);
  }, [onGoToMatter]);

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, color: DARK, marginBottom: 10 }}>
          Payment confirmed
        </div>
        <div style={{ fontSize: 13, color: '#AAA', lineHeight: 1.6 }}>{status}</div>
      </div>
    </div>
  );
}

// ── Payment Cancel Page ───────────────────────────────────────────────────────

export function PaymentCancel({ onGoToMatter }) {
  const params   = new URLSearchParams(window.location.search);
  const matterId = params.get('matter_id');

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✕</div>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, color: DARK, marginBottom: 10 }}>
          Payment cancelled
        </div>
        <div style={{ fontSize: 13, color: '#AAA', lineHeight: 1.6, marginBottom: 24 }}>
          No charge was made. Your matter and any uploaded documents are still saved.
        </div>
        <button
          onClick={() => matterId ? onGoToMatter(matterId) : onGoToMatter(null)}
          style={{
            background: DARK, color: '#FFF', border: 'none',
            padding: '10px 24px', borderRadius: 8, fontSize: 13,
            fontFamily: "'DM Sans', sans-serif", cursor: 'pointer',
          }}
        >
          Return to matter →
        </button>
      </div>
    </div>
  );
}

const overlay = {
  minHeight: '100vh', background: '#F7F5F0',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontFamily: "'DM Sans', system-ui, sans-serif",
};

const card = {
  background: '#FFF', borderRadius: 16, padding: '52px 60px',
  textAlign: 'center', boxShadow: '0 4px 32px rgba(13,27,42,0.08)',
  maxWidth: 420,
};
